import {FC} from 'react'
import { useIntl } from 'react-intl'

const Error500: FC = () => {
  const intl = useIntl()
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>{intl.formatMessage({id: 'System Error'})}</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        {intl.formatMessage({id: 'Something went wrong!'})} <br /> {intl.formatMessage({id: 'Please try again later'})} .
      </div>
    </>
  )
}

export {Error500}
